import "../components/TestimonialsSection.css";

export default function TestimonialsSection() {
  const testimonials = [
    {
      name: "DR.P.SARCAR",
      role: "MBBS, MD(Physician),DIP.CARD",
      text: "Natoshine products have transformed our patient care outcomes significantly.",
      image: "/professional-doctor-headshot.png",
    },
    {
      name: "Mahesh Prasad Paswan",
      role: "PHYSICIAN AND DIABETES ADVISER (PG DIPLOMA in ENDOCRINOLOGY & DIABETES)",
      text: "The quality and innovation in their pharmaceutical solutions are unmatched.",
      image: "/medical-professional-headshot.jpeg",
    },
    {
      name: "Dr. Emily Rodriguez",
      role: "Research Director",
      text: "Partnership with Natoshine has accelerated our research initiatives.",
      image: "/healthcare-professional-portrait.png",
    },
  ]

  return (
    <section className="testimonials-section">
      <div className="testimonials-container">
        <h2 className="testimonials-heading">What Healthcare Leaders Say</h2>

        <div className="testimonials-grid">
          {testimonials.map((testimonial, i) => (
            <div key={i} className="testimonial-card">
              <div className="testimonial-header">
                <img
                  src={testimonial.image || "/placeholder.svg"}
                  alt={testimonial.name}
                  className="testimonial-image"
                />
                <div className="testimonial-name-role">
                  <p className="testimonial-name">{testimonial.name}</p>
                  <p className="testimonial-role">{testimonial.role}</p>
                </div>
              </div>
              <p className="testimonial-text">"{testimonial.text}"</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

